var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.label)?_vm._t("label"):_vm._e(),(_vm.label)?_c('h4',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.lookupText))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }